<template>
    <a-modal v-model="visibles" width="1000px" :footer="null" :maskClosable="false" :confirmLoading="loading" title="预览发送" centered class="modal-box" @ok="handlerSubmit" @cancel="handleCancel">
        <a-spin :spinning="loading">
            <a-table :row-key="(record) => record.target" :pagination="false" :columns="columns" :data-source="previewList">
                <div slot="content" slot-scope="text, record">{{ record.sign ? '【'+record.sign+'】' : '' }}{{record.content}}</div>
            </a-table>
         </a-spin>
        <div class="t-c mt30">
            <a-button @click="handlerSubmit" style="width:120px" type="primary">立即发送</a-button>
        </div>
    </a-modal>
</template>

<script>
const columns = [
    {
        title:'姓名',
        dataIndex: 'name',
        key: 'name',
        width:100,
    },
    {
        title:'手机号',
        dataIndex: 'target',
        key: 'target',
        width:150,
    },
    {
        title:'耗费短信条数',
        dataIndex: 'num',
        key: 'num',
        width:150,
    },
    {
        title:'短信内容',
        dataIndex: 'content',
        key: 'content',
        scopedSlots: { customRender: 'content' },
    },
]
export default {
    name: "smsNotice",
    props: {},
    data() {
        return {
            columns,
            loading:true,
            visibles: false,
            previewList:[],
        };
    },

    components: {},

    computed: {
       
    },

    methods: {
        show(data) {
            this.__info = data;
            this.previewList = [];
            this.visibles = true;
            this.getPreviewData();
        },

        handleCancel(){
            this.visibles = false;
        },

        // 获取替换标签
        getPreviewData() {
            this.loading = true;
            this.$request.post({ url: 'smsPreview', data:this.__info }).then(res => {
                this.previewList = res.data;
            }).finally(() => {
                this.loading = false;
            })
        },

        handlerSubmit() {
            this.$request.post({ url: "smsSend", data: this.__info }).then(res => {
                this.$message.success('发送成功');
                this.$emit('ok');
                this.visibles = false;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
            })
        },
    },
    created() {
       
    },
    mounted() {
        this.__info = null;
    },
}
</script>

<style lang="less" scoped>
.modal-box{
     /deep/.ant-table{
        height: 80vh;
        overflow: auto;
    }
}
</style>
